import useSEO from "../../hooks/useSEO";

/**
 * SEO Component for managing page meta tags
 * @param {Object} props - Component props
 * @param {string} props.title - Page title
 * @param {string} props.description - Page description
 * @param {string} [props.keywords] - Meta keywords
 * @param {string} [props.ogImage] - Open Graph image URL
 * @param {string} [props.ogUrl] - Open Graph URL
 * @param {string} [props.ogType] - Open Graph type
 * @param {string} [props.canonical] - Canonical URL
 */
const SEO = ({
  title,
  description,
  keywords,
  ogImage,
  ogUrl,
  ogType = "website",
  canonical,
}) => {
  useSEO({
    title,
    description,
    keywords,
    ogTitle: title,
    ogDescription: description,
    ogImage,
    ogUrl,
    ogType,
    canonical,
  });

  return null;
};

export default SEO;
